var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { omit } from 'lodash';
var cls = classNames('svg-icon');
export var SvgIconDefaultProps = {
  size: 16,
  viewBoxSize: 96,
  colors: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    ", "\n  "], ["\n    ", ";\n    ", "\n  "])), theme.APPLY_COLORS, function (_a) {
    var _width = _a._width,
      _height = _a._height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), _width, _height);
  })
});
// -------- Components -------->
var My = {
  Container: styled.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SvgIcon = function (props) {
  var className = props.className,
    size = props.size,
    colors = props.colors,
    viewBoxSize = props.viewBoxSize,
    children = props.children,
    preserveAspectRatio = props.preserveAspectRatio,
    rest = __rest(props, ["className", "size", "colors", "viewBoxSize", "children", "preserveAspectRatio"]);
  var viewBox = props.viewBox || "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize);
  var _width = props.width || props.size;
  var _height = props.height || props.size;
  return React.createElement(My.Container, __assign({}, rest, {
    colors: omit(colors, 'background'),
    _width: _width,
    _height: _height,
    className: cls.name(className),
    viewBox: viewBox
  }), children);
};
SvgIcon.cls = cls;
SvgIcon.defaultProps = SvgIconDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;